'use strict';

/**
 * Абстрактный класс React-объекта.
 *
 * @abstract
 * @extends BaseObject
 * @since 5.6.0.1300
 */
var BaseReactObject = BaseObject.extend({

  /**
   * Конструктор.
   *
   * @private
   * @method BaseReactObject#init
   * @param model Модель React-компоненты.
   * @fires BaseReactObject.EVENTS#CLASS_INIT
   */
  init: function (model) {
    this._model = model;
    this._events = this._model.event;
    this.fire(BaseReactObject.EVENT.CLASS_INIT, this);
  },

  /**
   * Имя класса.
   *
   * @private
   * @property BaseReactObject#className
   * @override
   * @see BaseObject#className
   */
  className: 'BaseReactObject',

  /**
   * Список обработчиков событий.
   *
   * @private
   * @property BaseReactObject#_events
   * @override
   * @see BaseObject#_events
   */
  _events: null,

  /**
   * Модель React-компоненты.
   *
   * @private
   * @property BaseReactObject#_model
   */
  _model: null
});